import _memoize from 'lodash/memoize';
import { IMAGE_FIT_SCALE_CROP, IMAGE_QUALITY, TRANSPARENT_IMAGE_FORMAT } from '@bedrock-rdk/constants';
import { imageService } from '@bedrock/fido-sdk';
import { cacheResolver } from '../utils/style';

export const getProfilePhotoUrl = _memoize(
  ({ imageId, width, height }) =>
    imageService.getUrl(imageId, width, height, {
      format: TRANSPARENT_IMAGE_FORMAT,
      fit: IMAGE_FIT_SCALE_CROP,
      quality: IMAGE_QUALITY,
    }),
  cacheResolver,
);
